import { render, staticRenderFns } from "./ChoiboiLogo.vue?vue&type=template&id=75c2adaa&scoped=true&"
import script from "./ChoiboiLogo.vue?vue&type=script&lang=js&"
export * from "./ChoiboiLogo.vue?vue&type=script&lang=js&"
import style0 from "./ChoiboiLogo.vue?vue&type=style&index=0&id=75c2adaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c2adaa",
  null
  
)

export default component.exports